var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3307 4.33398H2.66406C2.1174 4.33398 1.66406 3.88065 1.66406 3.33398C1.66406 2.78732 2.1174 2.33398 2.66406 2.33398H29.3307C29.8774 2.33398 30.3307 2.78732 30.3307 3.33398C30.3307 3.88065 29.8774 4.33398 29.3307 4.33398Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89062 3.33398V19.294C4.89062 20.6007 5.50396 21.8407 6.55729 22.6273L13.504 27.8273C14.984 28.934 17.024 28.934 18.504 27.8273L25.4506 22.6273C26.504 21.8407 27.1173 20.6007 27.1173 19.294V3.33398H4.89062ZM21.3306 18.334H10.664C10.1173 18.334 9.66396 17.8807 9.66396 17.334C9.66396 16.7873 10.1173 16.334 10.664 16.334H21.3306C21.8773 16.334 22.3306 16.7873 22.3306 17.334C22.3306 17.8807 21.8773 18.334 21.3306 18.334ZM21.3306 11.6673H10.664C10.1173 11.6673 9.66396 11.214 9.66396 10.6673C9.66396 10.1207 10.1173 9.66732 10.664 9.66732H21.3306C21.8773 9.66732 22.3306 10.1207 22.3306 10.6673C22.3306 11.214 21.8773 11.6673 21.3306 11.6673Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.4fbba70962747be09be7782cd91b742e.svg";
export { ForwardRef as ReactComponent };